/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'xrx-time',
  templateUrl: './xrx-time.component.html',
  styleUrls: ['./xrx-time.component.less'],
  standalone: false,
})
export class XrxTimeComponent {
  @Input() set time(value: Time) {
    this._time = value;
    this.selectedHour = this.hours.filter((h) => h.value == this._time.hour)[0];
    this.selectedMinute = this.minutes.filter(
      (m) => m.value == this._time.minute,
    )[0];
  }
  @Input() placement: string;

  get time(): Time {
    return this._time;
  }
  @Output() change = new EventEmitter<Time>();
  @Output() timeChange = new EventEmitter<Time>();

  hours = [
    { key: 'one', value: '1' },
    { key: 'two', value: '2' },
    { key: 'three', value: '3' },
    { key: 'four', value: '4' },
    { key: 'five', value: '5' },
    { key: 'six', value: '6' },
    { key: 'seven', value: '7' },
    { key: 'eight', value: '8' },
    { key: 'nine', value: '9' },
    { key: 'ten', value: '10' },
    { key: 'eleven', value: '11' },
    { key: 'twelve', value: '12' },
  ];
  selectedHour: { key: string; value: string };
  minutes = [
    { key: 'zero', value: '00' },
    { key: 'fifteen', value: '15' },
    { key: 'thirty', value: '30' },
    { key: 'fortyfive', value: '45' },
  ];
  selectedMinute: { key: string; value: string };
  _time: Time = {
    hour: '12',
    minute: '00',
    ampm: 'am',
  };

  constructor() {}

  onChange(): void {
    this.change.emit(this.time);
  }
}

export interface Time {
  hour: string;
  minute: string;
  ampm: string;
}
